// Paraglide JS 순수 구현 - react-i18next 완전 제거
import { getLocale, setLocale } from '@paraglide/runtime';
import { I18N_LANG_KEY } from '@edusense/shared-constants';
/**
 * Paraglide JS 언어 변경 유틸리티
 * - Zero-runtime i18n 솔루션 
 * - 번들된 리소스만 사용 (HTTP 백엔드 없음)
 * - localStorage 키: I18N_LANG_KEY (통일된 언어 저장 키)
 */ export function changeLanguage(lng) {
    localStorage.setItem(I18N_LANG_KEY, lng);
    setLocale(lng, {
        reload: false
    });
    try {
        window.dispatchEvent(new CustomEvent('edusense:locale-changed', {
            detail: {
                locale: lng
            }
        }));
    } catch (e) {}
}
/**
 * 현재 언어 반환 (Paraglide JS 기본 기능)
 */ export function getCurrentLanguage() {
    return getLocale();
}
// Paraglide JS 기본 함수들 재 export
export { getLocale, setLocale };
// 레거시 호환성을 위한 기본 객체 (사용 지양)
export var paraglideLegacy = {
    getLocale: getLocale,
    setLocale: setLocale,
    changeLanguage: changeLanguage,
    language: getLocale()
};
